import { Box } from "@mui/material";
import classNames from "classnames";
import  React, {useState } from "react";
import { LanguageTickIcon } from "../../../../style/images";

export const LanguageSelector = ({data, onChange, value})=>{
    const [selected, setSelected] = useState({value})

    const onClick = (item) =>{
        setSelected(item);
        onChange(item)
    }
 
    return (<div className="language-list">
    {
        data.map(l=>
            <div className={classNames("language-item",{"selected":selected.value===l.name})} onClick={()=>{onClick(l)}}>
                {selected.value===l.name&& <Box component="img" src={LanguageTickIcon} sx={{width:"16px", height:"16px"}}></Box>}
                <span>{l.name}</span>
            </div>
        )
    }
    </div>)
}